<!-- This is so that we can test the component in ng serve but not display the component
when running in an actual application otherwise you see the user-profile component
for a moment before the actual application - kevin.low 06/22/22
-->
<div [ngStyle]="{'visibility': runningAsWebComponent? 'hidden' : 'visible'}">
  @if (token && authenticated) {
    <user-profile-element-component [route]="path" [token]="token"></user-profile-element-component>
  }
  <!-- <user-profile-element-component route='user-profile/account'></user-profile-element-component> -->
</div>


